/** Remove display-only break hints before measuring, searching or exporting text. */
export function stripSoftHyphens(text: string): string {
  return text.replace(/&shy;|&#0*173;|&#x0*ad;|\u00ad/gi, "");
}

/** React text nodes need the actual character, not a literal HTML entity. */
export function decodeSoftHyphens(text: string): string {
  return text.replace(/&shy;|&#0*173;|&#x0*ad;/gi, "\u00ad");
}

export function hyphenatedCaption(text: string, dictionary: Record<string, string>): string {
  return decodeSoftHyphens(text).replace(/[\p{L}\u00ad]+/gu, word =>
    decodeSoftHyphens(dictionary[stripSoftHyphens(word)] ?? word),
  );
}

/** Keep compound word parts intact, allowing a break after each visible separator. */
export function paletteCaptionParts(caption: string) {
  return caption.split(/(\s+)/).flatMap(token => {
    if (!/\S[/-]\S/.test(token)) return [{ text: token, unbreakable: false, breakAfter: false }];
    return token.split(/(?<=[/-])/).filter(Boolean).map(part => ({
      text: stripSoftHyphens(part),
      unbreakable: true,
      breakAfter: /[/-]$/.test(part),
    }));
  });
}
